import { AccountDisclaimers } from "Types/api/AccountDisclaimers";
import { AccountSettings } from "Types/api/AccountSettings";

// Includes only *supported* countries, matches https://schemas.dealerinspire.com/online-shopper/enums/country_codes.json
export enum CountryCode {
    US = "US",
    Canada = "CA",
    Guam = "GU",
}

/**
 * An account is a company that sells vehicles.
 */
export interface Account {
    // This property was not part of the generated Account type, but we use it to determine display - aw
    accessories_enabled: boolean;
    slug: string;
    url: string | null;
    name: string;
    /**
     * URL for a logo for this account. Typically short, wide, transparent, looks good on a blue background.
     */
    logo_header?: string | null;
    /**
     * URL for a logo for this account. Typically large, looks good on a white background.
     */
    logo_splash?: string | null;
    created_at?: string;
    updated_at?: string;
    /**
     * If the account is live, when they went live. Null if the account is still getting set up.
     */
    live_at?: string | null;
    primary_color?: string;
    secondary_color?: string;
    localization: {
        distance?: {
            unit: "mi" | "km";
            label: "miles" | "kilometers";
        };
        // getTypes just returns "[k: string]: any" instead of "currency". Adding the currency prop here explicitly.
        currency: string;
    };
    address?: {
        street?: string;
        city?: string;
        state?: string;
        /**
         * Field can contain US ZIP codes or Canadian Postal Codes
         */
        zip?: string;
        country?: CountryCode;
    };
    /**
     * Formatted for human readers, could contain letter substitution, punctuation, extensions, etc.
     */
    phone?: string;
    settings?: AccountSettings;
    account_disclaimers: AccountDisclaimers;
}
